// Authenticated REST client for the MongoDB backend.
//
// The admin panel keeps Firebase Auth; every request carries the admin's
// Firebase ID token, which the backend verifies (admin-only routes also check
// the `admin` custom claim). App data (users, agencies, salary, games, …) now
// lives in MongoDB, so use this instead of Firestore for those reads/writes.
import { auth } from './firebase';

export const API_URL = 'https://game.trustlive.online';

async function authHeader() {
  const user = auth.currentUser;
  if (!user) return {};
  const token = await user.getIdToken();
  return { Authorization: `Bearer ${token}` };
}

async function handle(res) {
  const text = await res.text();
  let data;
  try {
    data = text ? JSON.parse(text) : null;
  } catch (e) {
    data = text;
  }
  if (!res.ok) {
    const msg = (data && data.message) || `Request failed (HTTP ${res.status})`;
    const err = new Error(msg);
    err.status = res.status;
    throw err;
  }
  return data;
}

export async function apiGet(path) {
  const res = await fetch(`${API_URL}${path}`, { headers: { ...(await authHeader()) } });
  return handle(res);
}

export async function apiSend(method, path, body) {
  const res = await fetch(`${API_URL}${path}`, {
    method,
    headers: { 'Content-Type': 'application/json', ...(await authHeader()) },
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  return handle(res);
}

export const apiPost = (path, body) => apiSend('POST', path, body);
export const apiPatch = (path, body) => apiSend('PATCH', path, body);
export const apiDelete = (path, body) => apiSend('DELETE', path, body);

// Multipart file upload → returns { url, filename }. Replaces Firebase Storage
// uploadBytes + getDownloadURL. `folder` is the storage bucket (gifts/store/
// banners). `file` is a File or Blob.
export async function apiUpload(folder, file, filename) {
  const form = new FormData();
  form.append('file', file, filename || file.name || 'upload');
  const res = await fetch(`${API_URL}/api/upload/${folder}`, {
    method: 'POST',
    headers: { ...(await authHeader()) }, // no Content-Type: browser sets the boundary
    body: form,
  });
  return handle(res);
}

// Convert a data: URL (e.g. a generated SVGA thumbnail) into a Blob so it can be
// uploaded with apiUpload (replaces Storage uploadString base64).
export function dataUrlToBlob(dataUrl) {
  const [head, b64] = dataUrl.split(',');
  const mime = (head.match(/data:(.*?);base64/) || [])[1] || 'image/png';
  const bin = atob(b64);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  return new Blob([bytes], { type: mime });
}
